import React, { useState, useEffect } from 'react';
import { Activity, XCircle, Loader2 } from 'lucide-react';
import { auditAPI } from '../services/api';

const AuditLogModal = ({ onClose }) => {
  const [logEntries, setLogEntries] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetchAuditLog();
  }, []);

  const fetchAuditLog = async () => {
    try {
      const response = await auditAPI.getAll();
      setLogEntries(response.data);
    } catch (error) {
      console.error('Error fetching audit log:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-gray-900 bg-opacity-95 flex items-center justify-center p-4 z-50">
      <div className="bg-gray-800 rounded-xl shadow-2xl w-full max-w-4xl h-full md:h-5/6 p-6 overflow-y-auto">
        <div className="flex justify-end">
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-white transition p-2 rounded-full"
          >
            <XCircle className="w-8 h-8" />
          </button>
        </div>
        
        <div className="p-6">
          <h3 className="text-2xl font-bold text-gray-100 mb-4 flex items-center">
            <Activity className="w-6 h-6 mr-2 text-red-400" /> سجل تدقيق النظام
          </h3>
          <p className="text-sm text-gray-300 mb-6">
            عرض آخر 50 إجراء إداري مسجل عبر جميع المستخدمين.
          </p>
          
          {isLoading ? (
            <div className="text-center py-4">
              <Loader2 className="w-5 h-5 animate-spin mx-auto text-red-400" />
              <p className="text-gray-400 mt-2 text-sm">جاري تحميل سجل التدقيق...</p>
            </div>
          ) : (
            <div className="space-y-3 max-h-[70vh] overflow-y-auto pr-2">
              {logEntries.map((log) => (
                <div key={log.id} className="p-3 bg-gray-700 rounded-lg border-l-4 border-red-500 shadow-md text-sm">
                  <div className="flex justify-between items-center text-gray-300 mb-1">
                    <span className="font-bold text-red-300">{log.action}</span>
                    <span className="text-xs">{new Date(log.timestamp).toLocaleString()}</span>
                  </div>
                  <p className="text-xs text-gray-400">
                    <strong>دور الممثل:</strong> <span className="font-mono text-red-200">{log.actor_role}</span> | <strong>معرف المستخدم:</strong> <span className="font-mono text-red-200">{log.actor_id.substring(0, 8)}...</span>
                  </p>
                  <details className="mt-1">
                    <summary className="text-gray-400 text-xs cursor-pointer hover:text-red-400">
                      عرض التفاصيل
                    </summary>
                    <pre className="mt-2 p-2 bg-gray-900 rounded text-xs text-green-300 whitespace-pre-wrap break-all">
                      {log.details ? JSON.stringify(JSON.parse(log.details), null, 2) : 'لا توجد تفاصيل محددة مسجلة.'}
                    </pre>
                  </details>
                </div>
              ))}
              {logEntries.length === 0 && <p className="text-gray-400">لم يتم تسجيل أي إجراءات بعد.</p>}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AuditLogModal;
